export default __webpack_public_path__ + "static/media/W2GIF-2.fd2afcf6.gif";